import "../fonts/fonts.css";
import mediaQueries from "./media-queries";
import backgrounds from "../imgs/backgrounds";

const main = (area, method, productId) => {
  let styles = {
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    minHeight: method === "redirect" ? "100vh" : "100%",
    height: "100%",
    position: "relative",
    zIndex: 1
  };

  if (/Edit|Border|Text|Filter|Label|Accessibility|Privacy|Terms|Error|ProductSelector/.test(area)) {
    styles.background = `url(${backgrounds.pattern}) repeat left top`;
    styles.backgroundSize = "none";
  }

  if (/CropPhoto/.test(area)) {
    styles.background = "#FFFFFF";
  }

  if (/Landing|TutorialVideo/.test(area) && productId !== undefined) {
    styles.background = `url(${backgrounds[productId].mobile}) no-repeat`;
    styles.backgroundSize = "contain";
    styles[mediaQueries.hackTable] = {
      background: `url(${backgrounds[productId].desktop}) no-repeat center`,
      backgroundSize: "cover"
    };
  }

  if (/SelectBackground/.test(area)) {
    styles.background = `none !important`;
  }

  return styles;
};

const content = (area) => {
  return {
    flex: "1 0 auto",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
    width: "100%",

    padding: "70px 0 25px",
    "& p" : {
      fontFamily: "JWSansBook"
    },
    [mediaQueries.desktop] : {
      padding: 
        area === 'Landing' ? "100px 0" : "100px 0 30px 0",
    }
  };
};

export default {
  main,
  content
}



// WEBPACK FOOTER //
// ./src/styles/app.js